import createStore from "@Stores/base-factories";
import { hookCustomFieldsList } from "@Stores/base-factories/store-list";
import hookSiteSelectedFactory from "@Stores/base-factories/store-site-selection"

const { Provider, useStore } = createStore()
  .extend(hookSiteSelectedFactory('siteId'))
  .extendHookCollectionFactory('customField')
  .extendHookCollectionsFactory('customFields')
  .extend(hookCustomFieldsList())
  .factory()

export {
  Provider as FieldProvider,
  useStore as useFieldStore,
}
